import { formatNumber } from '@angular/common';

export function unlimitedParse(num: number | string): string {
  if (num === undefined) {
    return;
  }

  num = typeof num !== 'number' ? parseInt(num, 10) : num;

  if (num >= 500_000_000) {
    return 'Unlimited';
  } else {
    return formatNumber(num, 'en-US', '1.0-0');
  }
}
